import { api } from "../../api";
import { BulkAddImportStatsResult } from "../BulkAddDialogTypes";

/**
 * Generator function that asynchronously yields progress updates for an import process.
 * Yields numerator, denominator, and done.
 * Accepts an optional cancellation signal.
 *
 * @param {string} importId - The id of the import you want to track progress
 * @param {() => boolean} [isCancelled] - Optional function to check if polling should stop
 */
export async function* importProgress(
  importId: string,
  isCancelled?: () => boolean
): AsyncGenerator<BulkAddImportStatsResult> {
  function getNumeratorAndDenominator(stats: any) {
    const denominator = stats.number ?? 0;
    const numerator =
      (stats.number_no_action ?? 0) +
      (stats.number_completed ?? 0) +
      (stats.number_canceled ?? 0) +
      (stats.number_errored ?? 0);
    const done = denominator > 0 ? numerator >= denominator : false;
    return { numerator, denominator, done };
  }

  let done = false;
  while (!done) {
    if (isCancelled && isCancelled()) return;
    const { data: response } = await api.imports.importRowActionsStats({
      importId,
    });
    if (isCancelled && isCancelled()) return;
    const stats = response.data;
    const result = getNumeratorAndDenominator(stats);
    done = result.done;
    yield result;
    if (!done) {
      await sleep();
    }
  }
}

function sleep(seconds = 2) {
  return new Promise<void>(function (resolve) {
    setTimeout(resolve, seconds * 1000);
  });
}
